import { BehaviorSubject, Subject } from 'rxjs';
import { IClientInputContentRequestHttp } from 'client/models';

/** What the success page needs to offer Download PDF: the answers just submitted, in memory only. */
export interface IWebFormSubmissionCopy {
  formTitle: string;
  clientInputContents: IClientInputContentRequestHttp[];
  /** Rule-driven dropdown labels (field guid -> option key -> label) the server can't resolve itself. */
  optionLabels: Record<string, Record<string, string>>;
}

export const FormStore = {
  submitted$: new BehaviorSubject<boolean>(false),
  reset$: new Subject<void>(),
  touched$: new Subject<void>(),
  resize$: new Subject<void>(),
  successMsgKey: 'formSubmitSuccessMsg',
  token: '',
  // Labels of rule-driven dropdown options as shown on screen, recorded when each rule returns.
  ruleOptionLabels: {} as Record<string, Record<string, string>>,
  // The last successful submission, for the success page's Download PDF. Deliberately NOT in the
  // router state or browser storage: the answers are personal data, so they live only in memory and
  // are gone on refresh (the button then hides).
  lastSubmission: null as IWebFormSubmissionCopy | null
};
